import React from "react";
import { DollarSign } from "lucide-react";
import FunnelAssessmentViewerV2Base from "./FunnelAssessmentViewerV2Base";

const FunnelRevenueRealityAssessmentViewerV2 = ({ markdown }) => (
  <FunnelAssessmentViewerV2Base
    markdown={markdown}
    title="Revenue Reality"
    subtitle="Top-line health from revenue and demand signals"
    badge="Revenue"
    Icon={DollarSign}
  />
);

export default FunnelRevenueRealityAssessmentViewerV2;
